let currentObserver = null;
let updateData = {};

export const observe = fn => {
    currentObserver = debounceFrame(fn);
    fn(updateData);
    currentObserver = null;
}

export const observable = obj => {
    const observers = new Set();
    Object.keys(obj).forEach(key => {
        let _value = obj[key];
        Object.defineProperty(obj, key, {
            // currentObserver를 observers에 등록
            get() {
                if (currentObserver) {
                    observers.add(currentObserver);
                }
                return _value;
            },
            // observers에 등록된 모든 observer를 실행
            set(value) {
                if (_value === value) return Mutil.clog('이미 값이 같아서 옵저빙하지 않겠습니다.');
                //배열이나 객체인 경우에도 값이 같은지 체크필요
                if ((JSON.stringify(_value) === JSON.stringify(value))) {
                    return Mutil.clog('이미 같은 객체이므로 옵저빙하지 않겠습니다.');
                }
                _value = value;
                updateData = {[key]: value}
                observers.forEach(fn => fn(updateData));
            }
        })
    })
    return obj;
}

export const debounceFrame = (callback) => {
    let currentCallback = -1;
    return () => {
        cancelAnimationFrame(currentCallback);
        currentCallback = requestAnimationFrame(callback);
    }
};



